<script setup lang="ts">
import type { CalendarDraftPeriod, CalendarPeriod } from '../index'
import type { CalendarGetTimeSlots, CalendarTimeSlot } from './CalendarTimeTypes'
import { CellState } from '../index'
import CalendarTime from './CalendarTime.vue'

const props = withDefaults(
  defineProps<{
    /** Месяц для просмотра */
    day?: Date
    range?: boolean
    getSlots?: CalendarGetTimeSlots
    /** Natural height for a list containing several days. */
    scrollable?: boolean
    loading?: boolean
  }>(),
  {
    day: () => new Date(),
    range: false,
    getSlots: () => [],
    scrollable: true,
  },
)

defineEmits<{ select: [period: CalendarPeriod, isShift: boolean] }>()

const model = defineModel<CalendarDraftPeriod>({ default: () => ({}) })

const slots = computed(() => props.getSlots(props.day, model.value))

function getSlotState(slot: CalendarTimeSlot) {
  if (slot.selected) {
    return CellState.Selected
  }
  if (slot.disabled) {
    return CellState.Disabled
  }
  return CellState.Default
}
</script>

<template lang="pug">
.display-grid.grid-cols-5.column-gap-8(:class="scrollable ? 'row-gap-24 p-t-12 max-h-300 overflow-y-auto' : 'row-gap-12'")
  CalendarTime(
    v-for="slot of slots"
    :key="slot.value.start.getTime()"
    :label="slot.label"
    :state="getSlotState(slot)"
    :loading="loading"
    @click="$emit('select', slot.value, $event.shiftKey)"
  )
</template>
